import { loadPinnedMarkets, savePinnedMarkets } from '@/services/pinnedMarketsStorage';

export default {
  data() {
    return {
      pinnedMarkets: [],
    };
  },

  created() {
    this.pinnedMarkets = loadPinnedMarkets();
  },

  methods: {
    isPinned(market) {
      const mId = market.id || market.marketId;
      return this.pinnedMarkets.includes(mId);
    },

    togglePin(market) {
      const mId = market.id || market.marketId;
      if (this.isPinned(market)) {
        this.pinnedMarkets = this.pinnedMarkets.filter(p => p !== mId);
      } else {
        this.pinnedMarkets.unshift(mId);
      }
      savePinnedMarkets(this.pinnedMarkets);
    },
  },
};
